import { AttributionChip } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

// A pair of inline accept / reject glyphs for the `actions` slot. Pure render
// slot - the chip wires no behavior, the consumer owns the handlers.
function AcceptRejectActions() {
  return (
    <>
      <button
        type="button"
        aria-label="Accept"
        className="inline-flex h-4 w-4 items-center justify-center rounded-full text-success hover:bg-success/10"
      >
        ✓
      </button>
      <button
        type="button"
        aria-label="Reject"
        className="inline-flex h-4 w-4 items-center justify-center rounded-full text-destructive hover:bg-destructive/10"
      >
        ✕
      </button>
    </>
  );
}

// ~12 minutes ago, so the relative-time formatter renders a stable "12m ago".
const TWELVE_MIN_AGO = new Date(Date.now() - 12 * 60 * 1000).toISOString();

export function AttributionChipDemo() {
  return (
    <Section
      id="attribution-chip"
      title="AttributionChip"
      description="Small floating chip that attributes an inline edit / comment / suggestion to a user. Composes the Avatar primitive plus a name + relative timestamp and a right-side actions slot (accept / reject, view comment). Positioning is consumer-owned: floating is position:absolute (wrap in a relative anchor and offset with top/left), inline drops the absolute positioning for sidebar lists of recent edits."
    >
      <VariantBlock label="Floating" caption="position:absolute - anchored inside a relative preview frame, like an inline edit overlay">
        <div className="relative h-20 w-72 rounded-md border border-dashed border-border bg-muted/30">
          <AttributionChip
            name="Ada Lovelace"
            timestamp={TWELVE_MIN_AGO}
            className="left-3 top-3"
          />
        </div>
      </VariantBlock>

      <VariantBlock label="Tones" caption="default (human edit) and ai (accent-tinted suggestion source)">
        <div className="flex flex-wrap items-center gap-3">
          <AttributionChip placement="inline" tone="default" name="Ada Lovelace" timestamp={TWELVE_MIN_AGO} />
          <AttributionChip placement="inline" tone="ai" name="AIKO" timestamp={TWELVE_MIN_AGO} />
        </div>
      </VariantBlock>

      <VariantBlock label="With actions" caption="accept / reject mini-buttons in the right-side slot">
        <AttributionChip
          placement="inline"
          tone="ai"
          name="AIKO"
          timestamp={TWELVE_MIN_AGO}
          actions={<AcceptRejectActions />}
        />
      </VariantBlock>

      <VariantBlock label="Compact + name only" caption="compact drops the timestamp; omitting timestamp leaves bare avatar + name">
        <div className="flex flex-wrap items-center gap-3">
          <AttributionChip placement="inline" compact name="Grace Hopper" timestamp={TWELVE_MIN_AGO} />
          <AttributionChip placement="inline" size="sm" name="Alan Turing" />
        </div>
      </VariantBlock>
    </Section>
  );
}
